import { useSmoothScroll } from '../providers/SmoothScrollProvider'

const CinematicShell = ({ children }) => {
  const { scrollProgress } = useSmoothScroll() ?? { scrollProgress: 0 }

  return (
    <div
      className="cinematic-app"
      style={{ '--scroll-progress': scrollProgress }}
    >
      <div className="cinematic-progress" aria-hidden="true" />
      <div className="cinematic-vignette" aria-hidden="true" />
      <div className="cinematic-grain" aria-hidden="true" />
      {children}
    </div>
  )
}

export default CinematicShell
